import { z } from 'zod'
import AdvisorClientEntityDtoSchema from './AdvisorClientEntityDtoSchema'
import { AdvisorClientContactDto } from '../../client/contact/models/AdvisorClientContactDto'

export namespace AdvisorClientDto {
   export const entitySchema = AdvisorClientEntityDtoSchema
   export type entity = z.output<typeof AdvisorClientEntityDtoSchema>

   export const primaryKeysSchema = AdvisorClientDto.entitySchema.pick({ id: true, advisorOrgId: true })
   export type primaryKeys = z.output<typeof primaryKeysSchema>

   export const withContactsSchema = AdvisorClientDto.entitySchema.extend({
      contacts: z.array(AdvisorClientContactDto.entitySchema),
   })
   export type withContacts = z.output<typeof AdvisorClientDto.withContactsSchema>

   /**
    * Input schema to get a list of emails sent to a client for a date range
    */
   export const emailListSchema = AdvisorClientDto.entitySchema.pick({ advisorOrgId: true, clientOrgId: true }).merge(
      z.object({
         fromDate: z.string().datetime({ message: 'Invalid from date' }),
         toDate: z.string().datetime({ message: 'Invalid to date' }),
      })
   )
   export type emailList = z.output<typeof AdvisorClientDto.emailListSchema>

   /**
    * Input schema to get a single email sent to a client
    */
   export const emailSchema = AdvisorClientDto.entitySchema.pick({ advisorOrgId: true }).merge(
      z.object({
         emailId: z.string(),
      })
   )
   export type email = z.output<typeof AdvisorClientDto.emailSchema>

   export const minimalSchema = AdvisorClientDto.entitySchema.pick({
      id: true,
      name: true,
      clientOrgId: true,
      status: true,
      xeroId: true,
      fyiId: true,
      primaryContactFullName: true,
      email: true,
      primaryContactPhoneNumber: true,
      linkStatus: true,
      lastUpdatedAt: true,
      accessUserIds: true,
   }).extend({
      myAccess: z.enum(['public', 'shared']),
   })
   export type minimal = z.output<typeof AdvisorClientDto.minimalSchema>
   export const minimalKeysArray = (Object.keys(minimalSchema.shape) as (keyof minimal)[])
      .filter(k => k !== 'myAccess')

   export const idWithNameSchema = AdvisorClientDto.entitySchema.pick({ id: true, name: true, clientOrgId: true })
   export type idWithName = z.output<typeof AdvisorClientDto.idWithNameSchema>

   export const minimalWithClientOrgIdSchema = AdvisorClientDto.entitySchema.merge(z.object({ clientOrgId: z.string().optional() }))
   export type minimalWithClientOrgId = z.output<typeof AdvisorClientDto.minimalWithClientOrgIdSchema>

   export const createSchema = AdvisorClientDto.entitySchema.pick({
      name: true,
      primaryContactFirstName: true,
      primaryContactLastName: true,
      email: true,
      primaryContactPhoneNumber: true,
      accessUserIds: true,
   })
   export type create = z.output<typeof AdvisorClientDto.createSchema>

   export const updateSchema = AdvisorClientDto.entitySchema.pick({
      name: true,
      primaryContactFullName: true,
      primaryContactPhoneNumber: true,
      status: true,
      email: true,
      xeroId: true,
      id: true,
      accessUserIds: true,
   })
   export type update = z.output<typeof AdvisorClientDto.updateSchema>

   export const updateStatusSchema = AdvisorClientDto.entitySchema.pick({ id: true, status: true })
   export type updateStatus = z.output<typeof AdvisorClientDto.updateStatusSchema>
}
